import * as React from 'react';
import DefaultTemplate from '../../_components/templates/DefaultTemplate';
import Settings from '../../_components/organisms/Settings';

const SettingsPage = () => {
  return <DefaultTemplate showSettings={false} body={<Settings />} />;
};

export default SettingsPage;
